import React from "react";
import { Link } from "react-router-dom";

function PolicyPage({
  eyebrow = "Customer care",
  title,
  intro,
  lastUpdated = "12 August 2026",
  sections,
  relatedLinks = [],
}) {
  return (
    <main className="content-page policy-page" id="main-content">
      <div className="content-page__inner policy-page__inner">
        <header className="content-page__header policy-page__header">
          <p className="content-page__eyebrow">{eyebrow}</p>
          <h1 className="content-page__title">{title}</h1>
          {intro && <p className="content-page__intro">{intro}</p>}
          <p className="policy-page__updated">
            <span className="visually-hidden">Policy </span>
            last reviewed {lastUpdated}
          </p>
        </header>

        <article className="policy-page__body">
          {sections.map(({ id, title: sectionTitle, paragraphs = [], items = [] }) => (
            <section className="policy-page__section" id={id} key={id}>
              <h2 className="policy-page__section-title">{sectionTitle}</h2>
              {paragraphs.map((paragraph, index) => (
                <p className="policy-page__text" key={`${id}-paragraph-${index}`}>
                  {paragraph}
                </p>
              ))}
              {items.length > 0 && (
                <ul className="policy-page__list">
                  {items.map((item, index) => (
                    <li key={`${id}-item-${index}`}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </article>

        {relatedLinks.length > 0 && (
          <nav className="policy-page__related" aria-label="Related customer care">
            <h2 className="policy-page__related-title">Related information</h2>
            <ul className="policy-page__related-list">
              {relatedLinks.map(({ label, to }) => (
                <li key={to}>
                  <Link className="policy-page__related-link" to={to}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </main>
  );
}

export default PolicyPage;
